// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"8ab44547","884":"a931c7f0"}[chunkId] + ".chunk.js";
};